/**
 * Shortcut for `String.toUpperCase()`.
 *
 * @param source input string
 * @returns uppercase output string
 */
const toUpperCase = (source: string): string => source.toUpperCase();

export default toUpperCase;
